export enum ContextBarTarget {
    MAIN = 'main',
    ACTIONS = 'actions',
    DYNAMIC_ACTIONS = 'dynamic_actions',
}
